/*
 * Created Date: 20-12-2021, 7:32:39 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 EDUFIT GROUP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { createFilterOptions } from '@mui/material'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import CoreAutocomplete from './CoreAutocomplete'
import { useController } from 'react-hook-form'
import { REGEX } from '@Core/Helpers/Yup'
import { errorMsg } from '@Core/Helpers/Message'

const filter = createFilterOptions()
const checkRegexEmail = string => {
	return REGEX.EMAIL.test(string)
}
const CoreInputMultipleEmail = ({ control, name, label, ...resProps }) => {
	const { t } = useTranslation('common')
	const {
		field: { onChange }
	} = useController({
		control,
		name
	})

	const handleChange = useCallback(
		(event, values, reason) => {
			if (
				checkRegexEmail(
					reason === 'createOption'
						? event.target.value
						: reason === 'selectOption'
						? values[values.length - 1]?.inputValue
						: null
				) ||
				['clear', 'removeOption'].includes(reason)
			) {
				onChange(
					values
						.map(value => {
							return value?.inputValue || value
						})
						.filter(value => {
							return value.trim() !== ''
						}),
					{ shouldValidate: true }
				)
			} else {
				errorMsg(
					t(`{{value}} không đúng định dạng email, vui lòng kiểm tra lại`, {
						value: values[0]?.inputValue
					})
				)
			}
		},
		[name]
	)

	return (
		<CoreAutocomplete
			control={control}
			name={name}
			label={label}
			onChange={handleChange}
			filterOptions={(options, params) => {
				const filtered = filter(options, params)
				const { inputValue } = params
				if (inputValue !== '') {
					filtered.push({
						inputValue
					})
				}

				return filtered
			}}
			clearOnBlur
			isCreateable
			selectOnFocus
			handleHomeEndKeys
			isOptionEqualToValue={(option, value) => option === value}
			getOptionLabel={option => {
				if (typeof option === 'string') {
					return option
				}
				if (option.inputValue) {
					return `${t('Add')} "${option.inputValue}"`
				}
				return option.label
			}}
			renderOption={undefined}
			freeSolo
			multiple
			{...resProps}
		/>
	)
}

// CoreInputMultipleEmail.defaultProps = {}

CoreInputMultipleEmail.propTypes = {
	...CoreAutocomplete.type.propTypes
}

export default React.memo(CoreInputMultipleEmail)
